
export const orderIsOnRequest = (order) => {
    try {
        const changePending = order?.changeRequest && order?.changeRequest?.length && (order?.changeRequest||[])?.some(obj => !['Denied','Canceled','Cancelled','Completed','Success']?.includes(obj?.status))
        const voidPending = order?.voidRequest && order?.voidRequest?.length && (order?.voidRequest||[])?.some(obj => !['Denied','Canceled','Cancelled','Completed','Success']?.includes(obj?.status))
        const refundPending = order?.refundRequest && order?.refundRequest?.length && (order?.refundRequest||[])?.some(obj => !['Denied','Canceled','Cancelled','Completed','Success']?.includes(obj?.status))
        
        if(changePending) {
            return 'Change'
        } else if(voidPending) {
            return 'Void'
        } else if(refundPending) {
            return 'Refund'
        } 
    
    } catch (error) {
        console.error('Error in orderIsOnRequest:', error);
        return false;
    }
    return false;
}
